var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFundCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 14.6666C11.6819 14.6666 14.6667 11.6818 14.6667 7.99992C14.6667 4.31802 11.6819 1.33325 8.00001 1.33325C4.31811 1.33325 1.33334 4.31802 1.33334 7.99992C1.33334 11.6818 4.31811 14.6666 8.00001 14.6666Z",
    fill: "#CF6C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.16659C8.27333 9.16659 8.5 8.93992 8.5 8.66659V5.33325C8.5 5.05992 8.27333 4.83325 8 4.83325C7.72667 4.83325 7.5 5.05992 7.5 5.33325L7.5 8.66659C7.5 8.93992 7.72667 9.16659 8 9.16659Z",
    fill: "#FFEEDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61334 10.4134C8.58001 10.3334 8.53334 10.2601 8.47334 10.1934C8.40668 10.1334 8.33334 10.0868 8.25334 10.0534C8.09334 9.98675 7.90668 9.98675 7.74668 10.0534C7.66668 10.0868 7.59334 10.1334 7.52668 10.1934C7.46668 10.2601 7.42001 10.3334 7.38668 10.4134C7.35334 10.4934 7.33334 10.5801 7.33334 10.6668C7.33334 10.7534 7.35334 10.8401 7.38668 10.9201C7.42001 11.0068 7.46668 11.0734 7.52668 11.1401C7.59334 11.2001 7.66668 11.2468 7.74668 11.2801C7.82668 11.3134 7.91334 11.3334 8.00001 11.3334C8.08668 11.3334 8.17334 11.3134 8.25334 11.2801C8.33334 11.2468 8.40668 11.2001 8.47334 11.1401C8.53334 11.0734 8.58001 11.0068 8.61334 10.9201C8.64668 10.8401 8.66668 10.7534 8.66668 10.6668C8.66668 10.5801 8.64668 10.4934 8.61334 10.4134Z",
    fill: "#FFEEDC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundCircle);
export default __webpack_public_path__ + "static/media/fund-circle.6257d749a218f4704512ad953e2019a7.svg";
export { ForwardRef as ReactComponent };